import { EnemyActor } from "../../enemy-actors/EnemyActor";
import { GameVars } from "../../../../GameVars";
import { BzztTurretActor } from "../BzztTurretActor";
import { AudioManager } from "../../../../AudioManager";

export class LaserBeam extends Phaser.GameObjects.Container {

    private bzztTurretActor: BzztTurretActor;
    private enemyActors: EnemyActor[];
    private f: number;
    private framesDuration: number;
    private impact_x: number[];
    private impact_y: number[];
    private grade: number;

    constructor(scene: Phaser.Scene, bzztTurretActor: BzztTurretActor, enemyActors: EnemyActor[]) {

        super(scene);

        this.bzztTurretActor = bzztTurretActor;
        this.enemyActors = enemyActors;
        this.f = 0;
        this.framesDuration = GameVars.timeStepFactor === 1 ? 24 : 6;

        this.impact_x = [];
        this.impact_y = [];

        for (let i = 0; i < this.enemyActors.length; i++) {
            this.impact_x.push(this.enemyActors[i].x);
            this.impact_y.push(this.enemyActors[i].y - 20);
        }

        let emmission_x = this.bzztTurretActor.x + this.bzztTurretActor.canonLength * Math.cos(this.bzztTurretActor.cannon.rotation - Math.PI / 2);
        let emmission_y = this.bzztTurretActor.y + (this.bzztTurretActor.canonLength * Math.sin(this.bzztTurretActor.cannon.rotation - Math.PI / 2) - 40);

        let bolt = this.scene.add.sprite(emmission_x, emmission_y, "texture_atlas_3", "bolt_00");
        bolt.setOrigin(.5, 1);
        bolt.scaleY = Math.hypot(this.impact_y[0] - emmission_y, this.impact_x[0] - emmission_x) / bolt.height + .1;
        bolt.scaleX = .4 + .2 * this.bzztTurretActor.anutoTurret.level;
        bolt.setAngle(Math.atan2(this.impact_y[0] - emmission_y, this.impact_x[0] - emmission_x) * 180 / Math.PI + 90);
        this.add(bolt);

        if (bolt.scaleY < .2) {
            bolt.scaleY = .2;
        }

        bolt.anims.play("bolt");

        AudioManager.playSound("electric_zap", false, .55 + .15 * bzztTurretActor.anutoTurret.level, 1 - .1 * bzztTurretActor.anutoTurret.level);

        bolt.on("animationcomplete", () => {
            this.destroy();
        }, this);
    }

    public preUpdate(time: number, delta: number): void {

        // if (this.f ++ === this.framesDuration) {
        //     this.destroy();
        //     return;
        // }
    }
}
